import React from 'react'
import useChats from '../../../../lib/api/useChats'
import useMemoizedPathFor from '../../../../lib/pathFor'
import Button from '../../../common/Button'
import { useTranslation } from '../../../../lib/i18n'

const ChatAction = ({ profileId }) => {
  const { t } = useTranslation()
  const { chats } = useChats({ dm_user_id: profileId })
  const chatPage =
    (chats?.length || 0) > 0 ? chats[0].slug : `new?user_id=${profileId}`
  const chatHref = useMemoizedPathFor('chat', chatPage)

  return (
    <Button primary tiny href={chatHref}>
      {t('common.sendMessage')}
    </Button>
  )
}

export default ChatAction
